import separateThumbs from "../../utils/separateThumbs";

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/intro', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));

const { media, thumbs } = separateThumbs(allMedia)

export const intro = {
    title: 'Homemade Samoas Cookies',
    description: 'Only four ingredients: coconut, dates, chocolate chips and coconut oil. Vegan & gluten-free',
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    media: media,
    thumbnails: thumbs,
    storySummary: `Traditional Samoas, as much as we love them, are highly processed and made with lots of saturated fats and artificial flavoring. We’re skipping all of those extra ingredients like white sugar, corn syrup and sweetened condensed milk and making them with just medjool dates, toasted coconut and chocolate chips. I recommend using Lily’s chocolate chips or Hu Kitchen gems for less sugar!`,
    storyMore: ``,
    keywords: ['chocolate chips', 'coconut', 'cookies', 'samoas', 'girl scout cookies', 'medjool dates'],
    recipeCategory: ["Dessert"],
    cuisine: ["American"],
    id: 'samoas-cookies',
    author: 'Restaurant name'
}